import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'components/ui/grid';
import { Field, FormSection } from 'redux-form';
import { FormTextInput } from 'components/ui/index';
import { useI18n } from 'hooks/use_i18n';

const AddressFields = ({ disabled, validations }) => {
  const { t } = useI18n();
  return (
    <React.Fragment>
      <Row>
        <Col xs={12} md={8}>
          <Field
            label={t('components.ui.form.address_fields.street_name')}
            name="street_name"
            validate={validations.street_name}
            disabled={disabled}
            component={FormTextInput}
          />
        </Col>
        <Col xs={12} md={4}>
          <Field
            label={t('components.ui.form.address_fields.street_number')}
            name="street_number"
            validate={validations.street_number}
            disabled={disabled}
            component={FormTextInput}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={4}>
          <Field
            label={t('components.ui.form.address_fields.zip_code')}
            name="zip_code"
            validate={validations.zip_code}
            disabled={disabled}
            component={FormTextInput}
          />
        </Col>
        <Col xs={12} md={8}>
          <Field
            label={t('components.ui.form.address_fields.city')}
            name="city"
            validate={validations.city}
            disabled={disabled}
            component={FormTextInput}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

AddressFields.defaultProps = {
  validations: {
    street_name: [() => {}],
    street_number: [() => {}],
    zip_code: [() => {}],
    city: [() => {}],
  },
};

AddressFields.propTypes = {
  disabled: PropTypes.bool,
  validations: PropTypes.object,
};

export default AddressFields;
